export const mixPanelEventTitles = {
  submit_logistic_address: 'First Steps - Registered Address Screen',
  submit_company_information: 'First Steps - Registered Company Data Screen',
  submit_liable_partner: 'First Steps - Registered Personal Data Screen',
};
